import React, { useEffect, useRef } from 'react';
import { SearchItem } from '../../../types';
import PreviewPopover from './PreviewPopover';
import { StyledSearchItem } from '../styles';

interface Props {
	item: SearchItem;
	className: string;
	dataId: string;
	dataSrc?: string;
	children: React.ReactNode;
	extensions?: string[];
	activeSearchResultId?: string;
}

export function Item({
	item,
	className,
	dataId,
	dataSrc,
	children,
	extensions,
	activeSearchResultId,
}: Props) {
	const ref = useRef<HTMLLIElement>(null);

	const isItemSelected = activeSearchResultId === item.id;

	useEffect(() => {
		if (isItemSelected && ref.current) {
			ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
	}, [isItemSelected]);

	return (
		<>
			<StyledSearchItem
				className={className}
				isItemSelected={isItemSelected}
				data-id={dataId}
				data-id-hash={item.idHash}
				data-src={dataSrc}
				ref={ref}
			>
				{children}
			</StyledSearchItem>
			<PreviewPopover imageSrc={dataSrc || ''} imageExtensions={extensions || []} ref={ref} />
		</>
	);
}
